import type { OktaUser } from '~/types/tShared';

import { EnhancedUserState } from '../enhanceUser';

export const SET_USER = 'SET_USER';

export interface UserState extends EnhancedUserState {
  user: OktaUser;
  loaded: boolean;
  unprefixedRoles: string[];
}

export interface SetUserAction {
  type: typeof SET_USER;
  user: OktaUser;
}
